import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';

export function NavCustomerButton() {
  return (
    <Hyperlink
      className="nav__item button clear secondary nav__button hide_on--mobile"
      href="/avis"
      source="header"
    >
      <FormattedMessage id="navigation/customers/NavCustomerButton.tsx/1" />
    </Hyperlink>
  );
}
